import { createContext } from "react";

const StatusLogContext = createContext();

export default StatusLogContext;
